import './common'
import '../scss/style.scss';

import '~components/input/input'
import '~components/popup/popup'

import '~components/filter/filter'
import '~components/gallery/gallery'
import '~components/rating-bar/rating-bar'
import '~components/questions/questions'
import '~components/carousel/carousel'
import '~components/vote/vote'
import '~components/rating-bar/rating-bar'
import '~components/review/review'
import '~components/tabs/tabs'
import '~components/accordion/accordion'
import '~components/tooltip/tooltip'
import '~components/reservation/reservation'
import '~components/table/table'

$(window).on('load', function() {
    let copyLink = $('[data-copy-link]');

    copyLink.on('click', function() {
        navigator.clipboard.writeText(window.location.href);

        const html = `<div data-copy-alert><div class="alert alert--success" role="alert">Ссылка на товар скопирована в ваш буфер обмена.</div></div>`

        $(this).parent().parent().append(html);

        let alert = $(this).parent().parent().find('[data-copy-alert]');

        setTimeout(() => {
            alert.remove();
        }, 5000);
    });

    let scrollingButton = $('[data-scrolling-button]');

    initRightBlockSticky();

    $(window).on('resize', initRightBlockSticky);

    $(window).on('scroll', function() {
        let footerPos = $('[data-footer]').offset().top;

        if ($(window).scrollTop() + $(window).height() >= footerPos) {
            scrollingButton.addClass('hide');
        } else {
            scrollingButton.removeClass('hide');
        }
    });

    function initRightBlockSticky()
    {
        let addButton = $('[data-product-button]');
        let rightBlock = $('[data-product-right]');
        let header = $('[data-header]');
        let rightBlockStickyTop = rightBlock.offset().top;
        let addButtonStickyTop = addButton.offset().top;

        if (addButtonStickyTop > $(window).height()) {
            rightBlockStickyTop = $(window).height() + rightBlockStickyTop - (addButtonStickyTop + addButton.parent().height()) - 55;
        } else {
            rightBlockStickyTop = header.height() + 15;
        }

        rightBlock
            .addClass('sticky')
            .css({'top': `${rightBlockStickyTop}px`});
    }

    let confirmButton = $('[data-product-button]');

    confirmButton.on('click', checkRow);

    $('[data-product-right]').find('[data-size-checkbox]').on('change', checkRow);

    function checkRow(e)
    {
        let elem = $(this);
        let rows = $('[data-product-size-row]');
        let isButton = elem.is('[data-product-button]');
        let isCheckbox = elem.is('[data-size-checkbox]');
        let check = true;
        let uncheckedRows = [];

        if ($.inArray(window.selectedSkuId, window.basketSku) !== -1 && isButton) {
            location.href = '/personal/cart';
            return false;
        }

        if (isCheckbox) {
            elem.closest('[data-product-size-row]').find('[data-size-checkbox]').prop('checked', false);
            elem.prop('checked', true);
        }

        rows.each(function(i) {
            let rowsCheckboxes = $(this).find('[data-size-checkbox]');
            let checkedCheckboxes = [];

            rowsCheckboxes.each(function(checkbox) {
                if ($(this).is(':checked')) {
                    checkedCheckboxes.push($(this));
                }
            })

            if (checkedCheckboxes.length === 0 && isButton) {
                check = false;
                $(this).find('[data-checkbox-text]').addClass('focus');
                uncheckedRows.push($(this).attr('data-product-size-row'))
            } else if (checkedCheckboxes.length === 0 && isCheckbox) {
                uncheckedRows.push($(this).attr('data-product-size-row'))
            }
        });

        // ajax запрос сюда
        if (isButton && check) {
            // $.magnificPopup.open({
            //     items: {
            //         src: '#product-added',
            //     },
            //     closeMarkup: `<button title="close" type="button" class="mfp-close"></button>`,
            //     callbacks: {
            //         beforeOpen: function() {
            //             this.st.mainClass = 'mfp-add-popup';
            //             $('html').css({'overflow': 'visible', 'margin-right': ''});
            //         }
            //     }
            // });
        } else if (isButton && !check) {
            confirmButton.attr('disabled', '');

            if (uncheckedRows.length === 1) {
                confirmButton.text(`Выберите ${uncheckedRows[0]}`);
            } else {
                confirmButton.text('Выберите размер');
            }

            if ($(rows[0]).offset().top < $(window).scrollTop()) {
                $('html, body').animate({scrollTop: $(rows[0]).offset().top - $('[data-header]').height() - 40 + 'px'}, 500)
            }
        } else if (isCheckbox && check) {
            elem.closest('[data-product-size-row]').find('[data-checkbox-text]').removeClass('focus');

            if (process.env.NODE_ENV === 'development') {
                confirmButton.text('Добавить в корзину').removeAttr('disabled');
            } else {
                if (window.basketSku != undefined) {
                    if (window.basketSku.includes(window.selectedSkuId)) {
                        confirmButton.text('Перейти в корзину').removeAttr('disabled');
                    } else if (uncheckedRows.length === 0) {
                        confirmButton.text('Добавить в корзину').removeAttr('disabled');
                    }
                } else {
                    confirmButton.text('Добавить в корзину').removeAttr('disabled');
                }
            }
        }
    }
});
